import { Box } from '@mui/material'
import { useAppSelector } from 'app/state'
import { FeatureFlag, useFeatureFlag } from 'app/ui/useFeatureFlag'
import useBuilderMode from 'features/builder/hooks/useBuilderMode'

import { Map } from 'features/maps/types'
import useMapSharingInfo from 'features/maps/state/useMapSharingInfo'

import BuilderShareDialogButton from './BuilderShareDialogButton'
import BuilderHeaderActionsMenu from './BuilderHeaderActionsMenu'
import BuilderTakeover from './BuilderTakeover'

import { useViewerMapCredentials } from 'features/connections/hooks/useViewerMapCredentials'
import BuilderModeAndSettingsButton from './BuilderModeAndSettingsButton'
import useUserPermissions from 'features/account/state/useUserPermissions'
import useIsIndividualUser from 'features/users/state/useIsIndividualUser'

function BuilderHeaderActions({ viewOnly, currentMap }: { viewOnly?: boolean; currentMap?: Map }) {
  const { isEditable: isMapEditable } = useMapSharingInfo(currentMap)

  const { isEditorMode, isPreviewMode } = useBuilderMode()
  const collaborativeMapsEnabled = useFeatureFlag(FeatureFlag.CollaborativeMaps)

  const currentMapDatasets = useAppSelector((state) => state.maps.currentMapDatasets)
  const showDuplicateMap = currentMap?.title && currentMapDatasets.length !== 0

  const { sharingMapsAvailable } = useUserPermissions()
  const isIndividual = useIsIndividualUser()

  const { someCredentialsAttached } = useViewerMapCredentials()

  const isEditable = !viewOnly && isMapEditable
  const isCurrentMap = !!currentMap
  const displayRemoveCredentials = someCredentialsAttached && viewOnly
  const displayHeaderOptions = isCurrentMap && (isEditable || showDuplicateMap)
  const isEditorOrPreviewMode = isCurrentMap && (isEditorMode || isPreviewMode)
  const sharingAvailable = isEditorOrPreviewMode && (sharingMapsAvailable || !isIndividual)

  return (
    <>
      {collaborativeMapsEnabled && <BuilderTakeover />}
      {(displayHeaderOptions || displayRemoveCredentials || isEditorOrPreviewMode) && (
        <Box display="flex" gap={1}>
          {sharingAvailable && <BuilderShareDialogButton currentMap={currentMap} />}
          {isEditorOrPreviewMode && <BuilderModeAndSettingsButton isPreviewMode={isPreviewMode} />}

          <BuilderHeaderActionsMenu viewOnly={viewOnly} />
        </Box>
      )}
    </>
  )
}

export default BuilderHeaderActions
